export const serviceOptionsCanary = [];

export const serviceOptions = [
  { name: "anima-api", host: "api.animaapp.com" },
  { name: "anima-codegen", host: "codegen.animaapp.com" },
  //{ name: "figma-service" },  @or: not yet managed by argocd
  { name: "anima-web", host: "projects.animaapp.com" },
];

export const devOpsServiceColumns = [
  {
    label: "Date",
    prop: "date",
    formatter: (item) =>
      item.is_live ? `${item.date}  (Live release)` : item.date,
  },
  { label: "Author", prop: "author" },
  { label: "Message", prop: "message" },
];

export const canaryNames = [
  { name: "Canary", value: "canary" },
  { name: "Canary 1", value: "canary1" },
  { name: "Canary 2", value: "canary2" },
];
